import React from 'react'

import Home from '../components/Home'

const HomePage: React.FC = () => <Home />

export default HomePage
